export default __webpack_public_path__ + "static/media/CL13.de47a624.mp3";